import { QueryClient } from 'react-query';
// eslint-disable-next-line import/prefer-default-export
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // We do not really have any use for refetching on window focus globally.
            // It can instead be set per query
            // https://react-query.tanstack.com/guides/window-focus-refetching
            refetchOnWindowFocus: false,
        },
    },
});
